const SuggestionQueryKeys = {
  global: ["suggestions"] as const,
  v2Suggestion: () => [...SuggestionQueryKeys.global, "v2"] as const,
};

export { SuggestionQueryKeys };
